module.exports = {
      id: "google-g-usage",
      viewBox: "0 0 46 46",
      url: "/" + "sprite-f96a299a5e63739e5b36582e48c149a3.svg#google-g",
      toString: function () {
        return this.url;
      }
    }